import React from 'react';
import _ from 'lodash';
import { formatMoney } from '../utils/money';
import {
  RowFlexBox,
} from '../Components';
import { getTranslateByScope } from '../i18n';

const translate = getTranslateByScope('app.productDetail');

export const PriceSummary = ({ values, currency }) => {
  const keys = _.keys(values);
  const colWStyle = { minWidth: '100px', textAlign: 'right' };
  const colMStyle = { display: 'inline-block', minWidth: '48px' };

  const prices = _.reverse(keys).map((v) => (
    <div key={v}>
      <RowFlexBox flexDirection="row" style={{ paddingBottom: '5px' }}>
        <div style={{}}>{v}</div>
        <div style={{ flexGrow: 1 }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <span style={colMStyle}>
{`${translate('priceSummary.unitPrice')}:`}
{' '}
            </span>
            <span style={colWStyle}>{formatMoney(values[v].unitPrice, currency)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <span style={colMStyle}>
{`${translate('priceSummary.msrpPrice')}:`}
{' '}
            </span>
            <span style={colWStyle}>{formatMoney(values[v].msrpPrice, currency)}</span>
          </div>
        </div>
      </RowFlexBox>
    </div>
  ));

  return prices;
};
